import { getId } from "helpers/functions";
import {
  GET_ALL_CONTACTUSS,
  GET_ALL_CONTACTUSS_SUCCESS,
  GET_ALL_CONTACTUSS_FAILURE,
  EDIT_CONTACTUS,
  EDIT_CONTACTUS_SUCCESS,
  EDIT_CONTACTUS_FAILURE,
  DELETE_CONTACTUS,
  DELETE_CONTACTUS_SUCCESS,
  DELETE_CONTACTUS_FAILURE,
  GET_CONTACTUS,
  GET_CONTACTUS_SUCCESS,
  GET_CONTACTUS_FAILURE,
  ADD_CONTACTUS,
  ADD_CONTACTUS_SUCCESS,
  ADD_CONTACTUS_FAILURE,
} from "./actionTypes";

const initialState = {
  contacts: [],
  loading: false,
  error: "",
  contact: {},
};

const stores = (state = initialState, action) => {
  switch (action.type) {
    // get all contacts
    case GET_ALL_CONTACTUSS:
      state = {
        ...state,
        loading: true,
      };
      break;

    case GET_ALL_CONTACTUSS_SUCCESS:
      state = {
        ...state,
        loading: false,
        contacts: action.payload.contacts,
      };
      break;

    case GET_ALL_CONTACTUSS_FAILURE:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      };
      break;

    // edit social type
    case EDIT_CONTACTUS:
      state = { ...state, loading: true };

      break;

    case EDIT_CONTACTUS_SUCCESS:
      state = {
        ...state,
        loading: false,
        contact: action.payload.social,
      };
      break;

    case EDIT_CONTACTUS_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    // get social type
    case GET_CONTACTUS:
      state = { ...state, loading: true };

      break;

    case GET_CONTACTUS_SUCCESS:
      state = {
        ...state,
        loading: false,
        contact: action.payload.contact,
      };
      break;

    case GET_CONTACTUS_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    // delete contact
    case DELETE_CONTACTUS:
      state = {
        ...state,
        loading: true,
      };

      break;

    case DELETE_CONTACTUS_SUCCESS:
      const socialTypesAfterDeleteing = [
        ...state?.contacts?.filter(
          (contact) => getId(contact) !== action.payload
        ),
      ];

      state = {
        ...state,
        loading: false,
        contacts: socialTypesAfterDeleteing,
      };
      break;

    case DELETE_CONTACTUS_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    // edit social type
    case ADD_CONTACTUS:
      state = { ...state, loading: true };

      break;

    case ADD_CONTACTUS_SUCCESS:
      state = {
        ...state,
        loading: false,
        contact: action.payload.contact,
      };
      break;

    case ADD_CONTACTUS_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default stores;
